import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPdf = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.264 13.0259C10.264 13.3796 10.1579 13.6626 9.94562 13.8395C9.73337 14.0164 9.415 14.1225 8.9905 14.1225H8.7075V15.2899H8V12H9.06125C9.45037 12 9.76875 12.0708 9.981 12.2476C10.1579 12.4245 10.264 12.7075 10.264 13.0259ZM8.67212 13.5565H8.88437C9.09662 13.5565 9.2735 13.5211 9.37962 13.415C9.48575 13.3089 9.5565 13.2027 9.5565 13.0612C9.5565 12.8844 9.52112 12.7782 9.415 12.7075C9.30887 12.6367 9.20275 12.6014 8.9905 12.6014H8.67212V13.5565V13.5565Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6946 13.6272C13.6946 14.1579 13.5531 14.5824 13.2347 14.8654C12.9163 15.1484 12.4918 15.2899 11.8905 15.2899H10.9707V12H11.9966C12.5272 12 12.9517 12.1415 13.2347 12.4245C13.5531 12.7075 13.6946 13.0966 13.6946 13.6272ZM12.9517 13.6272C12.9517 12.9197 12.6333 12.566 12.032 12.566H11.6782V14.6885H11.9612C12.6333 14.7239 12.9517 14.3701 12.9517 13.6272Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1458 15.2899H14.4736V12H16.3485V12.566H15.1458V13.415H16.2424V13.981H15.1458V15.2899Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0996 3V7.8H18.8996",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9 17V8.21421C18.9 7.949 18.7946 7.69464 18.6071 7.50711L14.3929 3.29289C14.2054 3.10536 13.951 3 13.6858 3H5.5C4.94771 3 4.5 3.44772 4.5 4V17",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 18.3V20C4.5 20.5523 4.94772 21 5.5 21H17.9C18.4523 21 18.9 20.5523 18.9 20V18.3",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
export default SvgPdf;
